<template>
  <!--
    Vuetify 3 translation notes — the V2 original used four props/slots that V3
    silently ignores, so this had drifted a long way from Bridge:
      `top`           -> `location="top"`  (no `top` in V3; it fell to BOTTOM)
      `:app`          -> dropped           (no such prop in V3)
      `content-class` -> dropped           (not a V3 VSnackbar prop, so the
                         subtitle/bold styling never applied — 14px/400 against
                         Bridge's 16px/700; hence the span below)
      `#action`       -> `#actions`        (renamed; the close button rendered
                         NOT AT ALL on V3, the worst of the four)
    `variant="text"` keeps the icon button flat: V2 icon buttons are transparent
    by default, V3's are not.
  -->
  <v-snackbar
    v-model="show"
    :timeout="timeout"
    color="secondary"
    location="top"
  >
    <span class="text-subtitle-1 font-weight-bold">{{ message }}</span>
    <template #actions>
      <v-btn icon variant="text" color="primary-darken-4" @click="show = false">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useSnackbarStore } from '~/stores/snackbar'
export default {
  data() {
    return {
      show: false,
      message: '',
      timeout: 1500,
    }
  },
  computed: {
    snack() {
      return useSnackbarStore().snack
    },
  },
  watch: {
    snack(newSnack, oldSnack) {
      const fn = `[components/defaultLayout/Snackbar.vue] (watch) snack |`
      console.debug(`${fn} snack changed:`, oldSnack, newSnack)
      if (newSnack?.message) {
        this.message = newSnack.message
        this.timeout = newSnack.timeout
        this.show = true
        useSnackbarStore().clear()
      }
    },
  },
}
</script>
